const PASS_TIERS = new Set(['moonfall_storyteller', 'moonfall_manga']);

/** Only server-derived gift facts are used for the pre-claim review. */
export function readGiftPreview(value, now = Date.now()) {
  if (!value || !PASS_TIERS.has(value.effectiveTier)) return null;
  for (const key of ['weeklyAllowancePercent', 'currentWeekSpentPercent', 'resultingPercent']) {
    if (!Number.isSafeInteger(value[key]) || value[key] < 0) return null;
  }
  for (const key of ['weeklyResetAt', 'giftEndsAt']) {
    if (!Number.isSafeInteger(value[key]) || value[key] <= now) return null;
  }
  if (value.reviewResetAt != null && (!Number.isSafeInteger(value.reviewResetAt) || value.reviewResetAt <= now)) return null;
  if (value.nextPaidTier != null) {
    if (!PASS_TIERS.has(value.nextPaidTier)
      || !Number.isSafeInteger(value.nextChargeAt) || value.nextChargeAt !== value.giftEndsAt) return null;
  }
  return value;
}

export function giftReviewDetail(value, uiText, language = 'en') {
  const date = (timestamp) => new Intl.DateTimeFormat(language, { dateStyle: 'medium', timeStyle: 'short' }).format(timestamp);
  const pass = (tier) => tier === 'moonfall_storyteller'
    ? uiText('store.storytellerPass', 'Storyteller Pass') : uiText('store.mangaPass', 'Manga Pass');
  const lines = [uiText('voucher.giftReviewNow',
    'On claim: {{pass}}, weekly allowance {{allowance}}%. Current-week use deducted for a boosted gift: {{spent}}%. Estimated Moonlight bar: {{total}}%. Boosted Manga gifts keep the higher old or new weekly allowance, never add them together; current-week use is counted once. An ordinary gift starts with a fresh 100% base. Old base Moonlight and unused leftovers do not stack. The final balance uses actual current-week use at claim.',
    { allowance: value.weeklyAllowancePercent, spent: value.currentWeekSpentPercent, pass: pass(value.effectiveTier), total: value.resultingPercent }),
  uiText('voucher.giftReviewWeekly',
    'The gift lasts 28 days from claim, with a fresh weekly clock. Its first weekly reset is {{reset}}; unused Moonlight expires at each reset and the normal base returns to 100%. A higher-tier gift starts a fresh 28 days, replacing the old base. The gift ends {{end}}.',
    { reset: date(value.weeklyResetAt), end: date(value.giftEndsAt) })];
  if (value.nextPaidTier) lines.push(uiText('voucher.giftReviewDeferred',
    'If the gift claim and billing change succeed, your paid {{pass}} waits until the gift ends. Its next normal paid billing cycle starts {{end}}, with a fresh normal weekly bar; the next charge is {{charge}}. Remaining paid weeks are not saved. The store confirms the billing change after the claim.',
    { pass: pass(value.nextPaidTier), end: date(value.giftEndsAt), charge: date(value.nextChargeAt) }));
  return lines.join('\n\n');
}
